export default __webpack_public_path__ + "static/AGaramondPro-Italic-e4c18f34d59178b1196b3f02ea206d15.otf";